import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

export const CTASection = () => {
  const { t } = useTranslation();
  return (
    <section data-testid="cta-section" className="bg-warm-ivory">
      <div className="mx-auto max-w-7xl px-5 pb-24 lg:px-10 lg:pb-32">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] bg-deep-ink px-8 py-16 text-warm-ivory lg:px-16 lg:py-24">
            <div className="grain absolute inset-0" aria-hidden="true" />
            <div className="relative max-w-2xl">
              <h2 className="font-serif text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                {t("home.finalCtaTitle")}
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-warm-ivory/75">
                {t("home.finalCtaText")}
              </p>
              <Link
                to="/book"
                data-testid="cta-book-button"
                className="group mt-8 inline-flex items-center gap-2 rounded-full bg-champagne-gold px-7 py-3.5 font-medium text-deep-ink transition-transform hover:scale-[1.02]"
              >
                {t("home.finalCtaButton")}
                <ArrowRight className="rtl-flip h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
